// Lightweight logger that stays silent in production builds and only
// emits to the console during local development.
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn:  (...args) => { if (isDev) console.warn(...args); },
  info:  (...args) => { if (isDev) console.info(...args); },
};

export default log;
